import ReactTooltip from "react-tooltip";

import styles from "./index.module.scss";
import ProfileIcon from "../ProfileIcon";
import ProfilePreview from "../ProfilePreview";

type PropsType = {
  id: string;
  user: { first_name: string; last_name: string; role: { name: string } };
  userRole?: boolean;
};

const ProfileButton = ({ id, user, userRole }: PropsType) => {
  return (
    <>
      <div data-tip data-for={id}>
        <ProfileIcon
          name={`${user.first_name} ${user.last_name}`}
          userRole={user.role.name}
          size="medium"
        />
      </div>
      <ReactTooltip
        wrapper="span"
        id={id}
        type="dark"
        place="bottom"
        effect="solid"
        multiline
        backgroundColor={styles.grey_500}
        className={styles.tip}
        role="status"
        aria-live="polite"
        eventOff="blur"
      >
        <ProfilePreview
          size="medium"
          user={user}
          userRole={userRole}
        />
      </ReactTooltip>
    </>
  );
};

export default ProfileButton;
